import React, { Component } from 'react';
import styled from 'styled-components';

import isMobile from '../../utils/mediaWidth/isMobile';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import { getDirectionCheckboxes } from '../../utils/directionsData';

import Layout from '../../components/Layout';
import Final from '../../modules/RazorAndBlade/Final';
import Start from '../../modules/RazorAndBlade/Start';
import Phases from '../../modules/RazorAndBlade/Phases';
import form from '../../components/PopupForm/PopupForm';
import dataPhases from '../../modules/RazorAndBlade/consts/dataPhases';
import MobileNextPhase from '../../modules/RazorAndBlade/MobileNextPhase';

export const screens = {
    start: 'start',
    phases: 'phases',
};

const screenComponents = {
    [screens.start]: Start,
    [screens.phases]: Phases,
};

const correctScroll = () => {
    window.scrollTo(0, 0);
};

class RazorAndBlade extends Component {
    constructor(props) {
        super(props);

        this.state = {
            screen: screens.start,
            phase: 0,
            subPhase: 0,
            stage: 0,
            isReadyStage: false,
        };

        this.changeStage = this.changeStage.bind(this);
        this.changePhase = this.changePhase.bind(this);
        this.changeSubPhase = this.changeSubPhase.bind(this);

        this.backToStart = this.backToStart.bind(this);
        this.showDiscussForm = this.showDiscussForm.bind(this);
        this.showCurrentPhase = this.showCurrentPhase.bind(this);
    }

    changeScreen(newScreen, phase = 0) {
        const { screen } = this.state;
        if (newScreen in screens && newScreen !== screen) {
            this.setState({
                screen: newScreen,
                phase,
                subPhase: 0,
                stage: 0,
                isReadyStage: false,
            }, correctScroll);
        }
    }

    changePhase(newPhase) {
        const { phase } = this.state;
        const phasesLen = dataPhases.length;

        if (newPhase > phasesLen - 1) {
            this.showFinal();
        } else if (newPhase !== phase) {
            this.setState({
                isReadyStage: false,
                phase: newPhase,
                subPhase: 0,
                stage: 0,
            }, correctScroll);
        }
    }

    changeSubPhase(newSubPhase, passCondition) {
        const { phase, subPhase, isReadyStage } = this.state;
        const { subPhases } = dataPhases[phase];
        const stagesLen = Object.keys(dataPhases[phase].subPhases[subPhase].stages).length;

        if (newSubPhase !== subPhase) {
            if (passCondition || isReadyStage) {
                if (newSubPhase > subPhases.length - 1) {
                    this.changePhase(phase + 1);
                } else {
                    this.setState({
                        subPhase: newSubPhase,
                        isReadyStage: false,
                        stage: 0,
                    }, correctScroll);
                }
            } else {
                this.setState({
                    isReadyStage: true,
                    stage: stagesLen - 1,
                }, () => {
                    if (isMobile()) {
                        this.showMobileNext();
                    }
                });
            }
        }
    }

    changeStage(newStage) {
        const { phase, subPhase, stage } = this.state;
        const stagesLen = Object.keys(dataPhases[phase].subPhases[subPhase].stages).length;

        if (newStage > stagesLen + 1) {
            this.changeSubPhase(subPhase + 1);
        } else if (newStage !== stage) {
            this.setState({
                stage: newStage,
            });
        }
    }

    showCurrentPhase(phase) {
        this.changeScreen(screens.phases, phase);
    }

    showDiscussForm() {
        const { handleOpenPopUp } = this.props;
        handleOpenPopUp(form, { checkboxes: getDirectionCheckboxes() });
    }

    showMobileNext() {
        const { handleOpenPopUp } = this.props;
        const { phase, subPhase } = this.state;
        handleOpenPopUp(MobileNextPhase, {
            callbackClose: () => this.closePopupCallback(),
            next: () => this.changeSubPhase(subPhase + 1),
            results: dataPhases[phase].subPhases[subPhase].results,
            risks: dataPhases[phase].subPhases[subPhase].risks,
            openForm: this.showDiscussForm,
        });
    }

    showFinal() {
        const { handleOpenPopUp } = this.props;
        handleOpenPopUp(Final, {
            callbackClose: this.backToStart,
            openForm: this.showDiscussForm,
        });
    }

    closePopupCallback() {
        this.setState({
            isReadyStage: false,
        });
    }

    backToStart() {
        this.changeScreen(screens.start);
    }

    render() {
        const {
            screen, phase, subPhase,
            stage, isReadyStage,
        } = this.state;
        const { handleChangePage } = this.props;

        const StageComponent = screenComponents[screen];

        return (
            <Layout handleChangePage={handleChangePage}>
                <Content>
                    <StageComponent
                        phase={phase}
                        stage={stage}
                        subPhase={subPhase}
                        isReadyStage={isReadyStage}
                        backToStart={this.backToStart}
                        changeStage={this.changeStage}
                        changePhase={this.changePhase}
                        changeSubPhase={this.changeSubPhase}
                        showDiscussForm={this.showDiscussForm}
                        showCurrentPhase={this.showCurrentPhase}
                    />
                </Content>
            </Layout>
        );
    }
}

const Content = styled.div`
  position: relative;
  & > div {
    min-height: calc(100vh - 272px);
    ${mediaWidth.m} {
      min-height: calc(100vh - 189px);
    }
    ${mediaWidth.xl} {
      min-height: calc(100vh - 190px);
    }
  }
`;

export default RazorAndBlade;
